import * as React from 'react';
import { FormGroup, Input } from 'reactstrap';
import { DropdownOption } from 'shared-client/types/fields';
import { StringFilterEditProps } from '../providers/SingleValue';
import FilterEditRequiredValidation from './FilterEditRequiredValidation';
import { FiltersListAddButton } from './index';

interface SingleDropDownFilterEditState {
	currentValue: string;
	displayValidationError: boolean;
}

export type SingleDropDownFilterEditProps = StringFilterEditProps & {
	dropdownValues: DropdownOption[];
};

/**
 * Configures a single dropdown value  within a filter
 */
class SingleDropDownFilterEdit extends React.Component<SingleDropDownFilterEditProps, SingleDropDownFilterEditState> {
	public static defaultProps = {
		value: '',
		enumValues: [],
	};

	constructor(props) {
		super(props);

		this.state = {
			currentValue: '',
			displayValidationError: false,
		};
	}

	/**
	 * Update local state when the controlled dropdown is updated
	 *
	 * @private
	 * @memberof SingleDropDownFilterEdit
	 */
	private handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({ currentValue: e.currentTarget.value });
	};

	/**
	 * Selects the value from the dropdown and updates the state.
	 *
	 * @private
	 * @memberof SingleDropDownFilterEdit
	 */
	private selectValue = () => {
		const trimmedValue = this.state.currentValue.trim();
		const validationError = !this.props.filter.nullable && !trimmedValue;

		this.setState({
			displayValidationError: validationError,
		});

		if (!validationError) {
			// let the parent component know what the new value is.
			this.props.onChange(trimmedValue, false);
		}

		this.setState({ currentValue: '' });
	};

	/**
	 * Allow users to hit enter to select new value.
	 *
	 * @private
	 * @memberof SingleDropDownFilterEdit
	 */
	private handleOnKeyDown = (e: React.KeyboardEvent) => {
		if (e.which === 13) {
			e.preventDefault();
			this.selectValue();
		}
	};

	public render() {
		const availableEnumValues = this.props.dropdownValues.filter(
			(enumValue) => !this.props.value.includes(enumValue.value.toString()),
		);

		return (
			<FormGroup>
				{availableEnumValues.length > 0 ? (
					<>
						<Input
							id="fieldValue"
							type="select"
							autoFocus
							value={this.state.currentValue}
							onKeyDown={this.handleOnKeyDown}
							onChange={this.handleOnChange}
							className=""
							autoComplete="off"
						>
							<option value="" />
							{availableEnumValues.map((status, index) => {
								return (
									<option key={index} value={status.value}>
										{status.text}
									</option>
								);
							})}
						</Input>
						<div className="filters-popover__actions">
							<FiltersListAddButton onClick={this.selectValue} />
						</div>
					</>
				) : (
					<p>No more values available.</p>
				)}
				{this.state.displayValidationError ? (
					<FilterEditRequiredValidation messageOverride="Field is required" />
				) : null}
				<p />
			</FormGroup>
		);
	}
}

export default SingleDropDownFilterEdit;
